module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"add_media":"新增照片/影片","add_photo":"新增照片","max_media_count":"（最多{0}個）","media_count_exceeded":"最多可上傳 {0} 個，因此在選擇的相片/影片中僅附加 {1} 個。","capture_excluded":"截圖無法上傳。將從所選照片/影片中排除後附加。","capture_excluded_and_media_count_exceeded":"將排除截圖，並僅附加{0}個照片/影片。"}}')
  delete Component.options._Ctor
}
